import { Routes } from '@angular/router';
import { roleGuard } from './core/guards/role.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { userDetailResolver } from './features/users/user-detail/user-detail.resolver';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [noAuthGuard],
    children: [
      {
        path: 'ms',
        loadComponent: () =>
          import('./features/ms-auth-redirect/ms-auth-redirect.component').then(
            (m) => m.MsAuthRedirectComponent,
          ),
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'error',
        loadComponent: () =>
          import('./features/auth-error/auth-error.component').then((m) => m.AuthErrorComponent),
      },
    ],
  },
  {
    path: '',
    canActivate: [roleGuard],
    loadComponent: () =>
      import('./layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: 'utilisateurs',
        loadComponent: () =>
          import('./features/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'utilisateurs/create',
        loadComponent: () =>
          import('./features/users/user-detail/user-detail.component').then(
            (m) => m.UserDetailComponent,
          ),
      },
      {
        path: 'utilisateurs/:id',
        loadComponent: () =>
          import('./features/users/user-detail/user-detail.component').then(
            (m) => m.UserDetailComponent,
          ),
        resolve: { user: userDetailResolver },
      },
      {
        path: 'import-vehicules',
        loadComponent: () =>
          import('./features/vehicle-import/vehicle-import.component').then(
            (m) => m.VehicleImportComponent,
          ),
      },
      {
        path: 'organes',
        loadComponent: () =>
          import('./features/organe/list/organe-list.component').then((m) => m.OrganeListComponent),
      },
      {
        path: 'marques',
        loadComponent: () =>
          import('./features/marque/list/marque-list.component').then((m) => m.MarqueListComponent),
      },
      {
        path: 'fournisseurs',
        loadComponent: () =>
          import('./features/fournisseur/list/fournisseur-list.component').then(
            (m) => m.FournisseurListComponent,
          ),
      },
      {
        path: 'workshops',
        loadComponent: () =>
          import('./features/workshop/list/workshop-list.component').then(
            (m) => m.WorkshopListComponent,
          ),
      },
      {
        path: 'tags',
        loadComponent: () =>
          import('./features/tag/list/tag-list.component').then((m) => m.TagListComponent),
      },
      {
        path: 'zones',
        loadComponent: () =>
          import('./features/zone/list/zone-list.component').then((m) => m.ZoneListComponent),
      },
      {
        path: 'filiales',
        loadComponent: () =>
          import('./features/subsidiary/list/subsidiary-list.component').then(
            (m) => m.SubsidiaryListComponent,
          ),
      },
      {
        path: 'traductions',
        loadComponent: () =>
          import('./features/translation/list/translation-list.component').then(
            (m) => m.TranslationListComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'utilisateurs',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
